import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

interface CreateSecurityProfileProps {
  securityProfileConfirmed?: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

const CreateSecurityProfile = ({
  securityProfileConfirmed,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: CreateSecurityProfileProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <>
          <InstructionCallout
            link={instructionsLink}
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            Open{' '}
            <AppLink
              href={instructionsLink}
              rel="noreferrer"
              target="_blank"
              showInFrame
              innerHtmlToScroll={instructionsInnerHtmlToScroll}
            >
              this guide
            </AppLink>{' '}
            to complete the steps below. Then click Continue.
          </InstructionCallout>
          <StyledInstructionBox>
            <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
              Create a Security Profile for Finch
            </InstructionItem>
            <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
              Assign the profile necessary permissions
            </InstructionItem>
            <InstructionItem index={3} badgeColor={COLORS.GRAY.GRAY_600}>
              Save the Security Profile
            </InstructionItem>
            <InstructionItem index={4} badgeColor={COLORS.GRAY.GRAY_600}>
              Enable the Service Account login configuration
            </InstructionItem>
          </StyledInstructionBox>
        </>
      )}
      <MainContainer useNewDesign>
        <InstructionsCheckbox
          checked={securityProfileConfirmed?.value === 'true'}
          onChange={(checked) =>
            securityProfileConfirmed?.onChange(checked ? 'true' : '')
          }
        />
      </MainContainer>
    </>
  );
};

export default CreateSecurityProfile;
